module.exports = __webpack_public_path__ + "static/media/lms.2e6db178.gif";